<template>
<div>
    <v-container>
        <div>
            <v-alert dismissible :value="successVisible" type="success" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
            <v-alert dismissible :value="errorVisible" type="error" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
        </div>
        <v-tabs centered v-model="tab">
            <v-tab href="#tab-details">
                Radiation-Source Device Update
            </v-tab>
            <v-tab href="#tab-checkworkflow">
                Shutter Check
            </v-tab>
            <v-tab href="#tab-dispose" :disabled="!isAdminUser">
                Dispose
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="tab-details">
                <v-container fluid>
                    
                        <v-form ref="formDetail" v-model="valid" lazy-validation >
                            <v-container>
                                <v-card outlined shaped loading="true">
                                    <v-card-title>
                                        Radiation - Source
                                        <v-spacer></v-spacer>
                                        <a :href="`/radiation/radiationprint/${radiationId}`" ><v-icon aria-hidden="false">mdi-printer-eye</v-icon></a>
                                    </v-card-title>
                                    <v-card-text>   
                                        <v-row>
                                            <v-col cols="3">
                                            <v-combobox dense label="Building" :readonly="!isAdminUser"  v-model="radiation.building" :items="buildings" :return-object="true" @change="onBuildingChange" :rules="[v=>!!v || 'Building is required']" required>
                                                <template #label>Building <span class="red--text"> <strong>*</strong></span></template>
                                            </v-combobox>
                                            <v-spacer></v-spacer>
                                            <v-dialog v-model="isBuildingDialogVisible" persistent max-width="290">
                                                <v-card>
                                                    <v-card-title class="text-h5">
                                                        Add New Building
                                                    </v-card-title>
                                                    <v-card-text>Do you want to add a new Building?</v-card-text>
                                                    <v-card-text>
                                                        <v-form ref="formNewBuilding" lazy-validation>
                                                        <v-text-field label="Code" v-model="newBuilding.code" prepend-icon="edit" :rules="[v=>!!v || 'Building Code is required']"></v-text-field>
                                                        <v-text-field label="Description" v-model="newBuilding.description" prepend-icon="edit" :rules="[v=>!!v || 'Building Description is required']"></v-text-field>
                                                        <v-card-actions>
                                                            <v-spacer>
                                                                <v-btn color="green darken-1" text @click="isBuildingDialogVisible=false">Cancel</v-btn>
                                                                <v-btn color="green darken-1" text @click="onSavingNewBuilding">Save</v-btn>
                                                            </v-spacer>
                                                        </v-card-actions>
                                                    </v-form>
                                                    </v-card-text>
                                                    
                                                </v-card>
                                            </v-dialog>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-combobox dense v-model="radiation.floor" :readonly="!isAdminUser" label="Floor" :items="floors" :return-object="true" @change="onFloorChange" :rules="[v=>!!v || 'Floor is required']" required>
                                                    <template #label>Floor <span class="red--text"> <strong>*</strong></span></template>
                                                </v-combobox>
                                                <v-spacer></v-spacer>
                                                <v-dialog v-model="isFloorDialogVisible" persistent max-width="290">
                                                    <v-card>
                                                        <v-card-title class="text-h5">Add New Floor</v-card-title>
                                                        <v-card-text>Do you want to add a new Floor?</v-card-text>
                                                        <v-card-text>
                                                            <v-form ref="formNewFloor" lazy-validation>
                                                                <v-text-field label="Floor" v-model="newFloor.code" append-icon="edit" :rules="[v=>!!v || 'Floor is required']"></v-text-field>
                                                                <v-card-actions>
                                                                    <v-btn color="green darken-1" text @click="isFloorDialogVisible=false">Cancel</v-btn>
                                                                    <v-btn color="green darken-1" text @click="onSavingNewFloor">Save</v-btn>
                                                                </v-card-actions>
                                                            </v-form>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-dialog>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-text-field dense v-model="radiation.location" :readonly="!isAdminUser" label="Location Description" :rules="[v=>!!v || 'Location is required']" required>
                                                    <template #label>Location Description<span class="red--text"> <strong>*</strong></span></template>-->
                                                </v-text-field>
                                                
                                            </v-col>
                                            <v-col cols="3">
                                                <v-combobox dense v-model="radiation.shutt" :readonly="!isAdminUser" label="Has a Shutter" :items="hasShutterOptions" :return-object="true" @change="onShutterChange" :rules="[v=>!!v || 'Has a Shutter is required']" required>
                                                </v-combobox>
                                            </v-col>
                                            
                                        </v-row>
                                        <v-row>
                                            <v-col cols="3">
                                                <v-text-field dense label="Serial Number" :readonly="!isAdminUser" v-model="radiation.serialNumber" :rules="[v=>!!v  || 'Serial Number is required']" required>
                                                    <template #label>Serial Number <span class="red--text"><strong>*</strong></span>

                                                    </template>
                                                </v-text-field>

                                            </v-col>
                                            <v-col cols="3">
                                                <v-combobox dense v-model="radiation.isotopes" :readonly="!isAdminUser" label="Isotope" :items="isotopes" @change="onIsotopeChange" :return-object="true" :rules="[v=>!!v || 'Isotope is required']" required >
                                                    <template #label>Isotope <span class="red--text"> <strong>*</strong></span></template>
                                                </v-combobox>
                                                <v-spacer></v-spacer>
                                                <v-dialog v-model="isIsotopeDialogVisible" persistent max-width="290">
                                                    <v-card>
                                                        <v-card-title class="text-h5"> Add New Isotope</v-card-title>
                                                        <v-card-text>Do you want to add a new Isotope?</v-card-text>
                                                        <v-card-text>
                                                            <v-form ref="formNewIsotope" lazy-validation>
                                                                <v-text-field label="Isotope" v-model="newIsotope.code" prepend-icon="edit" :rules="[v=>!!v || 'Isotope is required']"></v-text-field>
                                                                <v-card-actions>
                                                                    <v-btn color="green darken-1" text @click="isIsotopeDialogVisible=false">Cancel</v-btn>
                                                                    <v-btn color="green darken-1" text @click="onSavingNewIsotope">Save</v-btn>
                                                                </v-card-actions>
                                                        </v-form>
                                                        </v-card-text>
                                                        
                                                    </v-card>
                                                </v-dialog>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-text-field dense label="MCI" :readonly="!isAdminUser" v-model="radiation.mci" :rules="[v=>!!v || 'MCI is required']" required >
                                                    <template #label>MCI <span class="red--text"> <strong>*</strong></span></template>
                                                </v-text-field>
                                            </v-col>
                                            
                                        </v-row>
                                        
                                        <v-row>
                                            <v-col cols="3">
                                                <div>
                                                    <v-tooltip top color="warning">
                                                        <template v-slot:activator="{on, attrs}">
                                                            <div v-bind="attrs" v-on="on">
                                                                <v-select dense v-model="radiation.leak" :readonly="!isAdminUser" label="Leak Test Interval" :items="leaks" :return-object="true" 
                                                                    :rules="[v=>!!v || 'Leak Test Interval is required']" required>
                                                                    <template #label  >Leak Test Interval <span class="red--text"> <strong>*</strong></span></template>
                                                                </v-select>
                                                            </div>
                                                        </template>
                                                        <span>Leak meaning to be defined</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-col>
                                           
                                            <v-col cols="3">
                                                <v-select dense label="Leak Test Group" :readonly="!isAdminUser" :items="leakTestGroups" v-model="radiation.leakTestGroup" :return-object="true" :rules="[v=>!!v || 'Leak Test Group is required']" required>
                                                    <template #label>Leak Test Group <span class="red--text"> <strong>*</strong></span></template>
                                                </v-select>
                                            </v-col>
                                             
                                            <v-col cols="3">
                                                <v-combobox dense v-model="radiation.holder" :readonly="!isAdminUser" label="Holder" :items="holders" :return-object="true" 
                                                    @change="onHolderChange" :rules="[v=>!!v || 'Holder']" required>
                                                    <template #label>Holder <span class="red--text"> <strong>*</strong></span></template>
                                                </v-combobox>
                                                <HolderPanel :isVisible="showHolderDialog" :newHolder="newHolder" @close:isVisible="onCloseHolderPanel" @add:newHolder="onSaveHolderPanel"></HolderPanel>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-text-field dense label="Holder Serial Number" v-model="radiation.holderSerialNumber" :readonly="!isAdminUser">
                                                    <template #label>Holder Serial Number </template>
                                                </v-text-field>
                                            </v-col>
                                            
                                        </v-row>
                                        <v-row>
                                            <v-col cols="3">
                                                <v-text-field dense label="P&ID TAG" v-model="radiation.tag" :readonly="!isAdminUser" >
                                                    <template #label>P&ID TAG </template>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="3">
                                                <div>
                                                    <v-tooltip top color="warning">
                                                        <template v-slot:activator="{on,attrs}">
                                                            <v-text-field dense label="PO" v-model="radiation.po" :readonly="!isAdminUser" v-bind="attrs" v-on="on"
                                                                :rules="[v=>!!v || 'PO']" required>
                                                                <template #label>PO <span class="red--text"> <strong>*</strong></span></template>
                                                            </v-text-field>
                                                        </template>
                                                        <span>Po meaning to be defined</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-col>
                                            <!--
                                                <v-col cols="4">
                                                <v-text-field dense label="Source" v-model="radiation.source" :rules="[v=>!!v || 'Source']" required>
                                                    <template #label>Source <span class="red--text"> <strong>*</strong></span></template>
                                                </v-text-field>
                                                </v-col>0
                                            -->
                                        
                                        
                                            <v-col cols="3">
                                                <div>
                                                    <v-tooltip top color="warning">
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-text-field dense label="MFG" v-model="radiation.mfg" :readonly="!isAdminUser" v-bind="attrs" v-on="on" :rules="[v=>!!v || 'MFG']" required >
                                                                <template #label>MFG <span class="red--text"> <strong>*</strong></span></template>
                                                            </v-text-field>
                                                        </template>
                                                        <span>MFG meaning to be defined</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-col>
                                            <v-col cols="3">
                                                    <v-text-field dense label="Use Building" v-model="radiation.useBuilding" :readonly="!isAdminUser" >
                                                        
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="3">
                                                    <v-combobox dense label="install Status" v-model="radiation.installed" :readonly="!isAdminUser" :items="installedOptions" 
                                                        :return-object="true" :rules="[v=>!!v || 'install Status required']" required>
                                                        <template #label>Install Status <span class="red--text"><strong>*</strong></span> </template>
                                                    </v-combobox>
                                                </v-col>
                                
                                                <v-col cols="3">
                                                    <!--<v-text-field dense label="Secure By Lock and Cable" v-model="radiation.secureByLock"> </v-text-field>-->
                                                    <v-combobox dense :items="secureLoadOptions" label="Secure By Lock and Cable" v-model="radiation.secureByLock"
                                                        :readonly="!isAdminUser" 
                                                        :return-object="true" @change="onSecureByLockAndCableChange" :rules="[v=>!!v || 'Comment']" required >
                                                        <template #label>Secure By Lock and Cable <span class="red--text"> <strong>*</strong></span></template>
                                                    </v-combobox>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field dense label="Reason Not Secure" v-model="radiation.reasonNotSecure" :readonly="!isAdminUser"></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-menu 
                                                        ref="menu" 
                                                        v-model="menu" 
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y 
                                                        max-width="290px"
                                                        min-width="auto"
                                                        
                                                        >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field dense v-model="radiation.receiveDate"
                                                            :readonly="!isAdminUser"
                                                                label="Received Date"  
                                                                hint="MM/DD/YYYY Format"
                                                                persistent-hint
                                                                prepend-icon="mdi-calendar"
                                                                v-bind="attrs"
                                                                @blur="dateReceive=parseDate(radiation.receiveDate)"
                                                                v-on="on"
                                                                :rules="[v=>!!v || 'Receive Date']" required>
                                                                    <template #label>Received Date <span class="red--text"> <strong>*</strong></span></template>
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="dateReceive" :readonly="!isAdminUser" no-title @input="menu=false">
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            </v-row>
                                            
                                        <v-row>
                                            <v-col cols="6">
                                                
                                                
                                                    <v-combobox  
                                                        v-model="radiation.users"
                                                        :items="userList"
                                                        dense
                                                        hide-selected
                                                        multiple 
                                                        :readonly=true
                                                    >
                                                        <template #label>Area Management Contact<span class="red--text"><strong>*</strong></span></template>
                                                    </v-combobox>
                                                
                                            </v-col>
                                            <v-col cols="6">
                                                
                                                
                                                    <v-combobox  
                                                        v-model="radiation.mailing"
                                                        :items="userList"
                                                        dense
                                                        hide-selected
                                                        multiple 
                                                        :readonly=true >
                                                        <template #label>Primary Contact<span class="red--text"><strong>*</strong></span></template>
                                                    </v-combobox>
                                                
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field dense v-model="radiation.comment" :readonly="!isAdminUser" label="Comments"></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field dense :readonly=true disabled v-model="radiation.lastCheckDate" label="Last Shutter Check"></v-text-field>
                                            </v-col>
                                    </v-row>
                                    </v-card-text>
                                </v-card>
                                
                                <br/>
                               <ConfirmationPanel :isVisible="isConfirmVisible" :message="confirmMessage" @confirm:click="confirmSaving"></ConfirmationPanel>

                                <div class="text-right">
                                    <v-btn color="error" dark to="/radiation/radiationlist" style="margin-right:15px;" :disabled="!isAdminUser" >Cancel</v-btn>
                                    <v-btn dark color="success" @click="onSavingRadiation" style="margin-left: 15px;" :disabled="!isAdminUser">Save Device</v-btn>
                                </div>
                                
                            </v-container>
                        </v-form>    
                    
                    
                </v-container>
                
            </v-tab-item>
            <v-tab-item value="tab-checkworkflow">
                <v-container>
                     <v-form ref="formcheck" v-model="valid" lazy-validation >
                            <v-card elevation="2" outlined shaped>
                                <v-card-title>
                                    Shutter Check <v-spacer></v-spacer> Serial Number: <b>{{radiation.serialNumber}}</b>
                                </v-card-title>
                                <v-card-subtitle>Add a new comment</v-card-subtitle>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="3">
                                            <v-menu
                                                ref="menu3"
                                                v-model="menu3"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="check.dateCheckFormatted"
                                                        label="Date Check "
                                                        hint="MM/DD/YYYY format"
                                                        persistent-hint
                                                        prepend-icon="mdi-calendar"
                                                        v-bind="attrs"
                                                        @blur="dateCheck = parseDate(check.dateCheckFormatted)"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dateCheck"
                                                    no-title
                                                    @input="menu3 = false"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    
                                        <v-col cols="9">
                                            <v-combobox :items="commonReasons" label="Reason" v-model="check.reason" :return-object="true" @change="onReasonsChange" :rules="[v=>!!v || 'Reason']" required >
                                                <template #label>Reason <span class="red--text"> <strong>*</strong></span></template>
                                            </v-combobox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <div v-if="shutterCommentVisible">
                                                <v-text-field   v-model="check.comment" label="Comment" :rules="[v=>!!v || 'Comment']" required>
                                                    <template #label>Comment <span class="red--text"> <strong>*</strong> </span> </template>
                                                </v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="6">
                                            <div v-if="shutterDateVisible">
                                                <v-menu dense
                                                    ref="menuShutterDate"
                                                    v-model="menuShutterDate"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    max-width="290px"
                                                    min-width="auto">
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-text-field
                                                            v-model="check.dateShutterDateFormatted"
                                                            label="Next Check Due"
                                                            hint="MM/DD/YYYY format"
                                                            persistent-hint
                                                            prepend-icon="mdi-calendar"
                                                            v-bind="attrs"
                                                            @blur="dateShutter=parseDate(check.dateShutterDateFormatted)"
                                                            v-on="on"
                                                            :rules="[v=>!!v || 'Next Check Due Will Be Checked']" required>
                                                            <template #label>Next Check Due<span class="red--text"> <strong>*</strong> </span></template>
                                                        </v-text-field>
                                                    </template>
                                                    <v-date-picker 
                                                        v-model="dateShutter"
                                                        no-title
                                                        @input="menuShutterDate=false">

                                                    </v-date-picker>
                                                </v-menu>
                                            </div>
                                        </v-col>
                                        
                                    </v-row>
                                    
                                     <div class="text-right">
                                        <v-btn color="error" dark to="/radiation/radiationlist" style="margin:15px;">Cancel</v-btn>    
                                        <v-btn dark color="success" @click="onSaveComment" style="margin: 15px;">Save Comment </v-btn>
                                        
                                    </div>
                                </v-card-text>
                                
                            </v-card>
                        </v-form>
                        <br/>
                        
                        
                            <v-card elevation="2" outlined shaped> 
                                <v-card-subtitle>
                                    Comment List 
                                </v-card-subtitle>   
                                <v-card-text>
                                    <v-data-table
                                        :headers="headersComments"
                                        :items="comments"
                                        :items-per-page="5"
                                    >  
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                </v-container>   
            </v-tab-item>
            <v-tab-item value="tab-dispose" >
                <v-container>
                    <v-card elevation="2" outlined shaped>
                    <v-card-title>
                        Disposing <v-spacer></v-spacer> Serial Number: <b>{{radiation.serialNumber}}</b>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="formDispose" v-model="valid" lazy-validation>
                            <div class="d-inline-flex">    
                            </div>
                            <v-row>
                                <v-col cols="2" >
                                    <v-switch dense v-model="dispose.disposed" label="Disposal"></v-switch>    
                                </v-col>
                                <v-col cols="2">
                                    <v-menu
                                        v-model="menuDisposeDate"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field dense
                                                v-model="dispose.disposeDateFormatted"
                                                label="Disposal Date"
                                                hint="MM/DD/YYYY format"
                                                persistent-hint
                                                prepend-icon="mdi-calendar"
                                                v-bind="attrs"
                                                @blur="dateDispose = parseDate(dispose.disposeDateFormatted)"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="disposeDate"
                                            no-title
                                            @input="menuDisposeDate = false"
                                        >
                                        </v-date-picker>
                                    </v-menu>    
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field dense v-model="dispose.site" label="Disposal Site" ></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field dense v-model="dispose.mso" label="MSO"></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-checkbox dense label="Transfer Letter Filed" v-model="dispose.verified"></v-checkbox>
                                </v-col>
                            </v-row>
                        
                            <div class="text-right">
                                <v-btn color="error" dark to="/radiation/radiationlist" style="margin:15px;">Cancel</v-btn>    
                                <v-btn dark color="success" @click="onSaveDispose" style="margin: 15px;">Save Dispose </v-btn>
                                
                            </div>

                        </v-form>
                        
                    </v-card-text>
                </v-card>
                </v-container>
               
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</div>
</template>

<script>
import radiationAPI  from '@/services/radiationservice';
import userAPI from '@/services/userservice';
import moment from 'moment';
import HolderPanel from '@/views/radiation/HolderPanel';
import ConfirmationPanel from '@/views/commond/ConfirmationPanel';


class DropBoxAdapater{
    constructor(initializer){
        this.text=initializer.description;
        this.value=initializer.code;
        this.disabled=false;
        this.divider=false;
    }
}


class DropBoxUser{
    constructor(initializer)
    {
        this.text=initializer.name;
        this.value=initializer.userId;
        this.disabled=false;
        this.divider=false;
    }
}

class CommentAdapter{
    constructor(initializer)
    {
        this.id=initializer.id;
        this.radiationId=initializer.radiationId;
        this.userId=initializer.userId;
        this.checkDate= moment(String(initializer.checkDate)).format('MM/DD/YYYY');
        this.reason=initializer.reason;
        this.comments=initializer.comments;
        this.dateShutterWillBe=moment(String(initializer.dateShutterWillBe)).format('MM/DD/yyyy');
    }

    formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
    }

}

export default {
    name: "UpdateRadiation",
    props: {
     radiationId: String
    },
    data: function(){
        return {
            successVisible:false,
            errorVisible: false,
            shutterCommentVisible: false,
            shutterDateVisible: false,
            valid: false,
            isConfirmVisible:false,
            confirmMessage:'',
            tab: null,
            alertMessage: '',
            buildings: [],
            floors: [],
            isotopes: [],
            userList:[],
            shutts:[{value:'yes',text:'Yes'},
                {value:'no', text:'No'}
            ],
            leaks:[{value:'3YR',text:'3YR'},{value:'6MO',text:'6MO'}],
            leakTestGroups:[],
            headersComments:[
                { text:'Date Check', value:'checkDate'},
                { text:'User', value:'userId'},
                { text: 'Reason', value: 'reason'},
                { text:'Comments', value:'comments'},
                { text: 'Next Check Due', value:'dateShutterWillBe'}],
            hasShutterOptions:[
                { value:'false', text:'No'},
                { value: 'true', text:'Yes'}
            ],
            installedOptions:[],
            holders:[],
            radiation:{
                radiationId:0,
                building:null,
                floor:null,
                location:null,
                shutt:null,
                serialNumber:'',
                isotopes:null,
                mci:'',
                leak:null,
                leakTestGroup:'',
                holder:null,
                holderSerialNumber:'',
                tag:'',
                po:'',
                source:'',
                mfg:'',
                useBuilding:'',
                installed:null,
                secureByLock:'',
                reasonNotSecure:'',
                receiveDate: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                update: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                users:[],
                userChangeDate: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                mailing:[],
                mailingChangeDate: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                dispDate: null,
                dispSite: null,
                dispMSO: null,
                daysForInspection: 0,
                comment:'',
                lastCheckDate:null
            },
            isBuildingDialogVisible:false,
            newBuilding:{
                code:'',
                description:''
            },
            isFloorDialogVisible:false,
            newFloor:{
                code:'',
                description:''
            },
            isIsotopeDialogVisible:false,
            showHolderDialog:false,
            newIsotope:{
                code:'',
                description:''
            },
            newHolder:{
                code:'',
                description:''
            },
            check:{
                userId:'',
                dateCheckFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                reason: '',
                comment:'',
                dateShutterDateFormatted:null//this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))
            },
            dispose:{
                radiationId:0,
                disposed:false,
                disposeDateFormatted:this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                site:'',
                mso:'',
                verified: false
            },
            comments:[],
            dateReceive: moment(Date.now()).format('YYYY-MM-DD'),
            dateUpdate: moment(Date.now()).format('YYYY-MM-DD'),
            dateCheck: moment(Date.now()).format('YYYY-MM-DD'),
            dateShutter: moment(Date.now()).format('YYYY-MM-DD'),


            dateUserChange:  moment(Date.now()).format('YYYY-MM-DD'),

            dateMailingChange:  moment(Date.now()).format('YYYY-MM-DD'),
            
            disposeDate: moment(Date.now()).format('YYYY-MM-DD'),
            menu: false,
            menu2: false,
            menu3: false,
            menuUserChangeDate:false,
            menuMailingChangeDate:false,
            menuDisposeDate:false,
            menuShutterDate: false
            
        }
    }  ,
    computed:{
        computedDateFormatted(){
            
            return this.formatDate(this.dateCheck);
        },
        commonReasons(){
            return [
                { value:"shutterclosed", text:"Shutter closed and reopened freely"},
                { value:"cannotchecknow", text:"Cannot Check at this time."},
                { value:"stickingshutter", text:"Lubricated with Kroil Penetrating oil. Shutter Closed and Reopened Freely"},
                { value: "other", text:"Other. Please add Comment"}
            ]
        },
        secureLoadOptions(){
            return[
                {text:"Yes"},
                {text: "No"}
            ];
        },
        userAccount()
        {
            return this.$userAccount;
        },
        isAdminUser(){
            let foundIndex=this.$msal.data.user.idToken.roles.indexOf('radiation-admin-role');             
            if(foundIndex!=-1)
            {
                return true;    
            }
            else
            {
                return false;
            }
        }

    },
    watch:{
        dateCheck (val){
            console.log('datewatch',val);
            this.check.dateCheckFormatted=this.formatDate(this.dateCheck);
        },
        dateReceive(val)
        {
            this.radiation.receiveDate=this.formatDate(val);
        },
        dateUserChange(val){
            this.radiation.userChangeDate=this.formatDate(val);
        },
        dateMailingChange(val){
            this.radiation.mailingChangeDate=this.formatDate(val);
        },
        dateUpdate(val){
            this.radiation.update=this.formatDate(val);
        },
        disposeDate(val){
            console.log('dateDispose',val);
            this.dispose.disposeDateFormatted=this.formatDate(val);
        },
        dateShutter(val){
            this.check.dateShutterDateFormatted=this.formatDate(val);
        }

    },
    
    methods:{
        
        async selectUserByBuilding(buildingCode){
            
                await userAPI.getUsersByBuilding(buildingCode)
                .then(response=>{
                    if(response.data!=null){
                        
                        this.radiation.users=response.data;
                    }
                    else{
                        this.radiation.users=null;
                    }
                })
                .catch(error=>{console.log(error)}); 
        },
        async selectPrimaryContactByBuilding(buildingCode){
            await userAPI.getPrimaryContactByBuilding(buildingCode)
            .then(response=>{
                if(response!=null){
                    this.radiation.mailing=response;
                }
                else
                {
                    this.radiation.mailing=null;
                }
            })
            .catch(error=>{
                console.log(error)
            })
        },
        onBuildingChange: async function(dropBox){
             if(typeof(dropBox)==='string' && dropBox.trim()){
                var splited=[];
                var value='';
                if(dropBox.includes('-'))
                {
                    splited=dropBox.split('-');
                    value=splited[0].trim();
                    this.newBuilding={ code:splited[0].trim(), description:splited[1].trim()}
                }
                else{
                    value=dropBox;
                    this.newBuilding={ code:dropBox.trim()}
                }
                const item=this.buildings.find(building=>building.value===value);
                
                if(item){
                    this.radiation.building={value:item.value, text: item.value+' - '+ item.text };
                    this.selectUserByBuilding(item.value);
                    this.selectPrimaryContactByBuilding(item.value);
                } else{
                        this.isBuildingDialogVisible=true;   
                }
            }
            else{
                this.selectUserByBuilding(dropBox.value);
                this.selectPrimaryContactByBuilding(dropBox.value);
            }
        },
        onShutterChange: async function(dropBox){
            console.log(typeof(dropBox));
            if(typeof(dropBox)==='object')
            {
                this.radiation.shutt=dropBox;
            }
            else{
                this.radiation.shutt={ value:'false',text:'No'};
            }
        },
        async onSavingNewBuilding(){
            
            if(this.$refs.formNewBuilding.validate()){  
                
                var selected=null;
                await radiationAPI.addBuilding(this.newBuilding)
                    .then(response=>{
                        selected=response;
                    })
                    .catch(error=>{console.log(error)});
                this.loadBuildings();
                this.radiation.building={value: selected.code, text: selected.code+' - '+ selected.description };
                console.log("Saving new building");
                this.isBuildingDialogVisible=false;
            }
            else{
                console.log("Validation error");
            }
        },

        async onFloorChange(dropBox){
            
            if(typeof(dropBox)==='string' && dropBox.trim()){
                const item=this.floors.find(floor=>floor.value===dropBox);
                if(item){
                    this.radiation.floor={value: item.value, text: item.text};
                } else {
                    this.newFloor.code=dropBox;
                    this.isFloorDialogVisible=true;
                }
            }
            
        },
        async onHolderChange(dropBox){
            if(typeof(dropBox)==='string' && dropBox.trim()){
                const item=this.holders.find(holder=>holder.value===dropBox);
                if(item){
                    this.radiation.holder={value: item.value, text: item.text};
                } else {
                    this.newHolder={code: dropBox, description: dropBox};
                    this.showHolderDialog=true;
                }
            }
        },
        async onReasonsChange(dropBox)
        {
            
            if(typeof(dropBox)==='object' && dropBox!==null){
                console.log('dropBox',dropBox);
                this.check.reason=dropBox.text;
                switch(dropBox.value){
                    case 'cannotchecknow':
                        //show comment and date 
                        this.shutterCommentVisible=true;
                        this.shutterDateVisible=true;
                    break;
                    case 'other':
                        //show  comment
                        this.shutterCommentVisible=true;
                        this.shutterDateVisible=false;
                    break;
                    default:
                        //hidde comment and date
                        this.shutterCommentVisible=false;
                        this.shutterDateVisible=false;
                }
                
               
            }
            else if(typeof(dropBox)==='string' && dropBox.trim()){
                this.check.comment=dropBox;
                
            }
        },
        async onSecureByLockAndCableChange(dropBox)
        {
            if(typeof(dropBox)==='object' && dropBox!==null){
                this.radiation.secureByLock=dropBox.text;
            } else if(typeof(dropBox)==='string' && dropBox.trim()){
                this.radiation.secureByLock=dropBox;
            }
        },
        async onSavingNewFloor()
        {
            if(this.$refs.formNewFloor.validate()){
                var selected=null;
                this.newFloor.description=this.newFloor.code;
                await radiationAPI.addFloor(this.newFloor).
                    then(response=>{
                        selected={value: response.code, text: response.description};
                    })
                    .catch(error=>{console.log(error)});
                await this.loadFloors();
                this.radiation.floor=selected;
                this.isFloorDialogVisible=false;
            } else{
                console.log('Validation Error');
            }
        },
        async onIsotopeChange(dropBox){
            if(typeof(dropBox)==='string' && dropBox.trim()){
                const item=this.isotopes.find(isotope=>isotope.value===dropBox);
                if(item){
                    this.radiation.isotope={value: item.value, text: item.text};
                } else {
                    this.newIsotope.code=dropBox;
                    this.isIsotopeDialogVisible=true;
                }
            }
        },
        async onSavingNewIsotope()
        {
            if(this.$refs.formNewIsotope.validate()){
                var selected;
                this.newIsotope.description=this.newIsotope.code;
                await radiationAPI.addIsotope(this.newIsotope).
                    then(response=>{
                        selected={value: response.code, text: response.description};
                    })
                    .catch(error=>{console.log(error)});
                await this.loadIsotopes();
                this.radiation.isotope=selected;
                this.isIsotopeDialogVisible=false;
            } else{
                console.log('Validation Error');
            }
        },
        validate: function() {
          return this.$refs.formDetail.validate();
        },

        onSaveComment:async function()
        {
            this.valid=this.$refs.formcheck.validate();

            if(this.valid){
                console.log("Saving Comment",this.radiation);
                if(this.shutterCommentVisible===false)
                    this.check.comment='';
                if(this.shutterDateVisible===false)
                    this.check.dateShutterDateFormatted=null;

                const model={
                    id:0,
                    radiationId:this.radiationId,
                    userId: this.$msal.data.user.userName,
                    checkDate: this.parseDate(this.check.dateCheckFormatted),
                    reason: this.check.reason,
                    comments: this.check.comment,
                    dateShutterWillBe: this.parseDate(this.check.dateShutterDateFormatted)
                };

                await radiationAPI.addCheckWorkflow(this.radiationId,model)
                .then(response=>{
                    
                    if(response.status===200 || response.status===201){
                        this.check.checkDate= new Date().toISOString().substr(0,10);
                        this.check.comment= 'Next comment';
                        
                        this.loadComments(this.radiationId);
                    }

                })
                .catch(error=>{console.log(error)});
            }
            
        },
        onSaveDispose:async function(){
            console.log('Saving Dispose ...');
            
            this.valid=this.$refs.formDispose.validate() && this.dispose.disposed;
            
            if(this.valid)
            {
                const model={
                    radiationId: this.radiationId,
                    disposed:this.dispose.disposed,
                    disposeDate: this.parseDate(this.dispose.disposeDateFormatted),
                    site: this.dispose.site,
                    mso: this.dispose.mso,
                    verified: this.dispose.verified
                }

                await radiationAPI.updateRadiationDispose(this.radiationId,model)
                .then(response=>{
                    if(response.status===200 || response.status===201){
                      this.alertMessage='This Radiation input has been disposed';
                      this.successVisible=true;
                      this.hideAlert();
                      this.dispose=response.data; 
                      console.log('response.data',response.data);
                      this.disposeDate=moment(response.data.disposeDate).format('YYYY-MM-DD');
                      this.dispose.disposeDateFormatted=this.formatDate(this.disposeDate);
                    }
                    else{
                        this.alertMessage='Dispose saving failed';
                        this.errorVisible=true;        
                    }
                    
                })
                .catch(error=>{console.log(error)});
            }
            else
            {
                console.log('debuging..');
                this.alertMessage='Dispose saving failed';
                this.errorVisible=true;
            }
            
        },
        onSavingRadiation:async function(){
            
            this.valid=this.validate();
            if(this.valid){
            
            this.confirmMessage="Save Radiation Source Changes";
            this.isConfirmVisible=true; 
            }
        },
        confirmSaving: async function(value){
              this.isConfirmVisible=false; 
                if(value)
                    this.onSaveRadiation();
        },
        onSaveRadiation: async function()
        {
            this.valid=this.validate();
            if(this.valid){
                const model={
                   radiationId:this.radiation.radiationId,
                   building:this.radiation.building.value,
                   floor:this.radiation.floor.value,
                   location:this.radiation.location,
                   shutt:this.stringToBoolean(this.radiation.shutt.value),
                   serialNumber: this.radiation.serialNumber,
                   isotope:this.radiation.isotopes.value,
                   mci:this.radiation.mci,
                   leak:this.radiation.leak.value,
                   leakTestGroup: this.radiation.leakTestGroup.value,
                   holder: this.radiation.holder.value,
                   holderSerialNumber:this.radiation.holderSerialNumber,
                   tag: this.radiation.tag,
                   item:this.radiation.item,
                   po: this.radiation.po,
                   source:this.radiation.source,
                   mfg:this.radiation.mfg,
                   useBuilding:this.radiation.useBuilding,
                   install: this.radiation.installed.value,
                   secureByLock: this.radiation.secureByLock ,
                   reasonNotSecure: this.radiation.reasonNotSecure,
                   receiveDate: this.parseDate(this.radiation.receiveDate),
                   update: this.parseDate(this.radiation.update),
                   //users: users,
                   //mailing: mailings ,
                   dispDate:null,
                   dispSite:null,
                   dispMSO: null,
                   comment: this.radiation.comment
                };

                console.log('Edited Radiation-model', model); 

                await radiationAPI.UpdateRadiation(this.radiationId,model)
                    .then(response=>{
                        if(response.status===200 || response.status===201){
                            this.alertMessage='Radiation Source changes were successfully saved';
                            this.successVisible=true;
                            this.hideAlert();
                            this.newRadiation=response.data.data;
                        }else{
                            this.alertMessage='Radiation Source changes were not saved';
                            this.errorVisible=true;
                        }
                    })
                    .catch(error=>{console.log(error)});
            }
        },
        hideAlert: function(){
             window.setInterval(()=>{
                this.successVisible=false;
                this.errorVisible=false;
            },10000);
        },
        loadBuildings: async function()
        {
            await radiationAPI.getAllBuildings()
            .then(response=>{
                 response.data.map((building)=>{
                   this.buildings.push({value: building.code, text: building.code + ' - '+ building.description});}) 
                })
            .catch(error=>{console.log(error)});
        },

        loadFloors: async function()
        {
            await radiationAPI.getFloors()
            .then(response=>{
                if(response.data!=null){
                    this.floors=response.data.map(floor=>new DropBoxAdapater(floor));
                }
                else{
                    this.floors=null;
                }
            })
            .catch(error=>{console.log(error)}); 
        },
        async loadIsotopes(){
            await radiationAPI.getIsotopes()
            .then(response=>{
                this.isotopes=response.data.map(isotope=>new DropBoxAdapater(isotope));
            })
            .catch(error=>{console.log(error)});
        },
        loadComments:async function(radiationId)
        {
            await radiationAPI.getCheckWorkFlows(radiationId)
            .then(response=>{
                this.comments=response.data.map(comment=>new CommentAdapter(comment));
            })
            .catch(error=>{console.log(error)});

            
        },
        loadHolders: async function(){
            await radiationAPI.getHolders()
            .then(response=>{
                this.holders=response.data.map(holder=>new DropBoxAdapater(holder));
            })
            .catch(error=>{console.log(error)});
        },
        formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
        },
        parseDate (date) {
           
            if (!date) return null;

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        stringToBoolean: function(string){
            switch(string.toLowerCase().trim()){
                    case "true": case "yes": case "1": return true;
                    case "false": case "no": case "0": case null: return false;
                default: return Boolean(string);
                }
        },
        onCloseHolderPanel: function(value){
            this.showHolderDialog=value;
        },
        onSaveHolderPanel: function(value){
            this.loadHolders();
            this.radiation.holder={value: value.code, text: value.description };
            this.showHolderDialog=false;
        } 
    },
    mounted: async function(){
        console.log('mounting');
        this.radiationId=this.$route.params.radiationId;
        this.valid=true;
        
        await this.loadBuildings();
        await this.loadFloors();
        await this.loadIsotopes();

        radiationAPI.getLeakTestGroups()
        .then(response=>{
            this.leakTestGroups=response.data.map(leakTestGroup=>new DropBoxAdapater(leakTestGroup))
        })
        .catch(error=>{console.log(error)});

        this.loadHolders();

        await radiationAPI.getInstallOptions()
        .then(response=>{
            console.log('Install Options',response);
            this.installedOptions=response.map(installOption=>new DropBoxAdapater(installOption));
        })
        .catch(error=>{console.log(error)});
        

        await userAPI.getUsers()
        .then(response=>{
            this.userList=response.data.map(user=> new DropBoxUser(user));
        })
        .catch(error=>{console.log(error)})

        await radiationAPI.getRadiation(this.radiationId)
        .then(response=> {
            console.log(response.status);
            if(response.status===200)
            {
                this.radiation=response.data;
                this.radiation.building={ value:response.data.building.value, text:response.data.building.value+' - '+response.data.building.text};
                this.selectUserByBuilding(response.data.building.value);
                this.selectPrimaryContactByBuilding(response.data.building.value);
                this.radiation.floor={value:response.data.floor.value, text:response.data.floor.text};
                this.radiation.shutt={value:response.data.shutt.value, text: response.data.shutt.text};
                this.radiation.leak={value: response.data.leak, text: response.data.leak };
                this.radiation.isotopes={value:response.data.isotopes.value, text:response.data.isotopes.text };
                this.radiation.holder={value:response.data.holder.value, text:response.data.holder.text};
                this.radiation.installed={ value:response.data.installed.value, text:response.data.installed.text};
                this.dateReceive=this.radiation.receiveDate;
                this.radiation.receiveDate=this.formatDate(this.radiation.receiveDate);
                this.dateUpdate=this.radiation.update;
                this.radiation.update=this.formatDate(this.radiation.update);
                console.log('original',this.radiation.userChangeDate);
                this.radiation.userChangeDate=moment(this.radiation.userChangeDate).format('YYYY-MM-DD');
                console.log('con moment',this.radiation.userChangeDate);
                this.dateUserChange=this.radiation.userChangeDate;
                this.radiation.userChangeDate=this.formatDate(this.radiation.userChangeDate);
                this.radiation.mailingChangeDate=moment(this.radiation.mailingChangeDate).format('YYYY-MM-DD');
                this.dateMailingChange=this.radiation.mailingChangeDate;
                this.radiation.mailingChangeDate=this.formatDate(this.radiation.mailingChangeDate);
                this.radiation.lastCheckDate=moment(this.radiation.lastCheckDate).format('MM-DD-yyyy');
                this.dispose.radiationId=response.data.radiationId;
                if(response.data.disposed)
                {    
                    this.dispose.disposed=response.data.disposed;
                    console.log('moment(response.data.dispDate).format(YYYY-MM-DD)',moment(response.data.dispDate).format('YYYY-MM-DD'));
                    this.disposeDate=moment(response.data.dispDate).format('YYYY-MM-DD');
                    this.dispose.disposeDateFormatted=this.formatDate(this.disposeDate);
                    this.dispose.site=response.data.dispSite;
                    this.dispose.mso=response.data.dispMSO;
                    this.dispose.verified=response.data.verified;
                }
                

            }
            
        })
        .catch(error=>{console.log(error)});

        this.loadComments(this.radiationId);
       
        
    },
    components:{
        HolderPanel,
        ConfirmationPanel
    }
}
</script>

<style scoped>
.chart-container {
  max-width: 100%;
}

.chart-option-select {
  max-height: 50vh;
  min-height: 10vh;
  overflow-y: scroll;
}
</style>



